<template>
  <div class="assignee-bar">
    <span class="assignee-bar__label">
      <v-icon size="14">mdi-account-multiple-outline</v-icon>
      Assigned
    </span>
    <AssigneeControl
      :assignees="assignees"
      :entity-type="entityType"
      :entity-id="entityId"
      size="md"
      @update:assignees="$emit('update:assignees', $event)" />
  </div>
</template>

<script setup>
import AssigneeControl from "@/components/dashboard/AssigneeControl.vue";

defineProps({
  assignees: { type: Array, default: () => [] },
  entityType: { type: String, required: true },
  entityId: { type: [String, Number], required: true },
});

defineEmits(["update:assignees"]);
</script>

<style lang="scss" scoped>
.assignee-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 6px 2px 14px;
}

.assignee-bar__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: $lh_font_family_dm_sans;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: $lh_color_blue_gray;
  white-space: nowrap;
}
</style>
